import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { HeadingText } from '@paypalcorp/pp-react';
import CategoryToolTile from './CategoryToolTile';
import { useFptiImpression } from '../../../lib/hooks';

const DETAILS_CTA_CONTENT_CATEGORY_KEY = 'content.categoryKey';
const DETAILS_CTA_CONTENT_LOCATION = 'content.location';

const DetailsTwofers = ({
  componentContent,
  fptiClick,
  fptiImpression,
  structuredPSData: { categories = [] },
  toolTileProps,
  experimentation = {}
}) => {
  const { title, apps } = componentContent;
  const {
    twofersExp: isTwofersEligible,
    v2LayoutExp: isNewLayoutEligible
  } = experimentation;
  const {
    flatPSData: { tools = {}, twofersIntelligentApps = [] }
  } = toolTileProps;
  const ref = useRef();
  useFptiImpression(ref, () => {
    fptiImpression({
      pageLink: 'twofers'
    });
  });

  const handleClickTool = ({ fptiLink, prod, PSUrl, categoryFPTI }) => {
    return () => {
      fptiClick({
        fptiLink,
        prod,
        pageLink: categoryFPTI,
        type: 'twofers'
      });
      fetch(PSUrl);
    };
  };

  const appKeys = apps.replace(/\s/g, '').split(',');

  const appList = Object.keys(tools)
    .filter(key => appKeys.indexOf(key) !== -1)
    .reduce((arr, key) => arr.concat(tools[key]), [])
    .sort((a, b) => appKeys.indexOf(a.appKey) - appKeys.indexOf(b.appKey));

  if (!isTwofersEligible || !isNewLayoutEligible) return null;

  // Twofers intelligent recommendations
  // Filter out apps where pp_{app}_last_asstn_dt exists
  const usedApps = twofersIntelligentApps.map(app => app.name);
  const filteredAppList = appList.filter(
    app => usedApps.indexOf(app.appKey) === -1
  );

  if (filteredAppList.length < 1) return null;

  // Set a maximum of n apps per row
  const MAX_APPS = 3;
  const sizedAppList = filteredAppList.slice(0, MAX_APPS);

  return (
    <section id="details-twofers">
      <div className="twofers">
        <div className="twofers-header">
          <HeadingText level={2}>{title}</HeadingText>
        </div>
        <div className="twofers-grid" ref={ref}>
          {sizedAppList.map((tool, index) => {
            const whichCategory = categories.find(
              category =>
                get(category, DETAILS_CTA_CONTENT_CATEGORY_KEY) ===
                tool.categoryKey
            );
            const path = `/businesstools/${get(
              whichCategory,
              DETAILS_CTA_CONTENT_LOCATION,
              ''
            )}`;
            return (
              <CategoryToolTile
                key={`twofers-row-tool-${index}`}
                handleClickTool={handleClickTool}
                tool={tool}
                fptiImpression={fptiImpression}
                toolTileProps={toolTileProps}
                path={path}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

DetailsTwofers.propTypes = {
  componentContent: PropTypes.object,
  fptiImpression: PropTypes.func.isRequired,
  fptiClick: PropTypes.func,
  toolTileProps: PropTypes.object,
  experimentation: PropTypes.object,
  structuredPSData: PropTypes.object
};

export default DetailsTwofers;
